import { getActivity, getUsernames } from '../../../api';
import { ActionsType, PropertyType, formatToISO } from '../../../common';
import { onRequest } from '../../services';

const logsInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const data = await getActivity({ token, page, query: '', perPage });

	return { ...data, bulkRows: [], currentPage: page, logsLoading: false };
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;

	return { partners };
};

const usersInit = async (state: PropertyType, payload: PropertyType) => {
	const { activePartners } = state;
	const data = await getUsernames({ ...payload, activePartners });

	return { users: data };
};

const getFiltersUrl = (filters: PropertyType[]) => {
	const urlFragments: string[] = [];

	filters.forEach((f) => {
		const value = f.name == 'start_date' || f.name == 'end_date' ? formatToISO(f.value) : f.value;
		urlFragments.push(`${f.name}=${value}`);
	});

	return `?${urlFragments.join('&')}`;
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters, perPage } = payload;
	const query = filters.length ? getFiltersUrl(filters) : '';

	const data = await getActivity({ token, page, query, perPage });

	return {
		...data,
		logsLoading: false,
		filtering: !!filters.length,
		currentPage: page,
	};
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { filtering, filters } = state;

	if (!filtering) return logsInit(payload);
	return onFilter(state, { ...payload, filters });
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ logsLoading: payload }),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	LOGS_INIT: (state, payload) => onRequest(() => logsInit(payload), true),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	USERS_INIT: (state, payload) => onRequest(() => usersInit(state, payload), true),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_FILTERS: (state, payload) => ({ filters: payload }),
	ACTIVE_PARTNERS: (state, payload) => ({ activePartners: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', logsLoading: false }),
};
